const INDUSTRY_STORAGE_KEY = 'selected_industry_id';

export const INDUSTRY_SCOPED_RESOURCES = [
  'platform_account_settings',
  'report_settings',
  'report_sponsored_settings',
  'conversion_reports',
  'media_platform_api_settings',
  'meta_api_data',
  'meta_api_data/aggregated-pixel',
  'campaign_settings',
  'default_google_campaign_settings',
  'top_brand_settings',
  'google_ads_bridges',
  'ads_actions',
  'ads_ingest_runs',
  'ads_write_settings',
  'ads_jobs',
];

export const getSelectedIndustryId = () => {
  const stored = localStorage.getItem(INDUSTRY_STORAGE_KEY);
  return stored ? parseInt(stored, 10) : null;
};

export const setSelectedIndustryId = (industryId) => {
  localStorage.setItem(INDUSTRY_STORAGE_KEY, String(industryId));
};

export const clearIndustryScopedCache = () => {
  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith('RaStore.') && key.endsWith('.listParams')) {
      const resource = key.replace('RaStore.', '').replace('.listParams', '');
      if (INDUSTRY_SCOPED_RESOURCES.includes(resource)) {
        keysToRemove.push(key);
      }
    }
  }
  keysToRemove.forEach(key => localStorage.removeItem(key));
};

export const appendIndustryIdToUrl = (url) => {
  const industryId = getSelectedIndustryId();
  if (!industryId) return url;

  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}industry_id=${industryId}`;
};
